export const FIREBASE = {
  apiKey: 'AIzaSyDIa0EHalY6TwIjUjjaT2H5FInAzOgE6Hs',
  authDomain: 'sludzy-azmodana.firebaseapp.com',
  databaseURL: 'https://sludzy-azmodana.firebaseio.com',
  projectId: 'sludzy-azmodana',
  storageBucket: 'sludzy-azmodana.appspot.com',
  messagingSenderId: '947336888909',
}



// WEBPACK FOOTER //
// ./src/lib/config.js